import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DateValue, DateSelectionType } from "@/types/newLinkBuilder";

interface CustomBuiltIndexState {
  // Date value state
  dateValue: DateValue;
  setDateValue: (
    value: DateValue | ((prev: DateValue) => DateValue)
  ) => void;
  setDateSelectionType: (type: DateSelectionType) => void;
  setDate: (date: string) => void;
  setDateCellReference: (reference: string) => void;

  // Input range state
  inputRange: string;
  setInputRange: (value: string) => void;

  // Formula state
  formula: string;
  setFormula: (value: string) => void;

  // Formula location state
  formulaLocation: string;
  setFormulaLocation: (value: string) => void;

  // Reset function
  reset: () => void;
}

export const useCustomBuiltIndexStore = create<CustomBuiltIndexState>()(
  persist(
    (set) => ({
      // Date value initial state
      dateValue: {
        selected: DateSelectionType.Date,
        date: "",
        dateCellReference: "",
      },
      setDateValue: (value) =>
        set((state) => ({
          dateValue:
            typeof value === "function"
              ? (value as (prev: DateValue) => DateValue)(state.dateValue)
              : value,
        })),
      setDateSelectionType: (type) =>
        set((state) => ({
          dateValue: {
            ...state.dateValue,
            selected: type,
          },
        })),
      setDate: (date) =>
        set((state) => ({
          dateValue: {
            ...state.dateValue,
            date,
          },
        })),
      setDateCellReference: (reference) =>
        set((state) => ({
          dateValue: {
            ...state.dateValue,
            dateCellReference: reference,
          },
        })),

      // Input range initial state
      inputRange: "",
      setInputRange: (value) => set({ inputRange: value }),

      // Formula initial state (not persisted, recalculated)
      formula: "",
      setFormula: (value) => set({ formula: value }),

      // Formula location initial state
      formulaLocation: "",
      setFormulaLocation: (value) => set({ formulaLocation: value }),

      // Reset function
      reset: () =>
        set({
          dateValue: {
            selected: DateSelectionType.Date,
            date: "",
            dateCellReference: "",
          },
          inputRange: "",
          formula: "",
          formulaLocation: "",
        }),
    }),
    {
      name: "customBuiltIndexFormData", // localStorage key
      partialize: (state) => ({
        // Only persist these fields, exclude formula (which is recalculated)
        inputRange: state.inputRange,
        formulaLocation: state.formulaLocation,
        dateValue: state.dateValue,
      }),
    }
  )
);

